

/** Matches `.request-url-field-group` URL field: 36px min-height, 11px type, 7px×10px padding */
export const REQUEST_BUILDER_KV_INPUT_CLASS =
  'request-builder-kv-input w-full rounded-md focus:outline-none';

export const REQUEST_BUILDER_KV_INPUT_STYLE = { minHeight: '36px' };

/** Vertical splitter: min height for request (Params…Body) — low = handle can sit closer to those tabs. */
export const REQUEST_RESPONSE_SPLITTER_MIN_REQUEST_PX = 60;

/** Vertical splitter: min height for response (Body… + status) — low = handle can sit closer to that tab row. */
export const REQUEST_RESPONSE_SPLITTER_MIN_RESPONSE_PX = 88;
